// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Buv5","footer":"ModalFilter_footer__1uQSe"};